module.exports = __webpack_public_path__ + "media/宣传片.674273dc.mp4";